import { Grid, Heading } from '@zappyrent/hundop';
import {
  I18nextContext,
  Trans,
  useTranslation,
} from 'gatsby-plugin-react-i18next';
import { upperFirst } from 'lodash';
import React from 'react';

import { cities, getListingUri } from '../../lib/config';
import {
  StyledHead,
  StyledLink,
  StyledList,
  StyledListItem,
} from './OurCitiesList.styles';

const OurCitiesList = (): JSX.Element => {
  const { language } = React.useContext(I18nextContext);
  const { t } = useTranslation(['product', 'geo']);

  return (
    <>
      <Grid container>
        <StyledHead>
          <Heading tag="h2" sm="32px" md="56px" lg="56px">
            <Trans
              components={{ span: <span /> }}
              i18nKey="ourCitiesList"
              t={t}
            />
          </Heading>
        </StyledHead>
        <StyledList>
          {cities.map((city, index) => {
            const cityLabel = t(`geo:${city}`);
            const titleCityLabel = upperFirst(cityLabel);
            const title = `${t('product:apartmentsForRent')} ${t(
              'product:atLocation',
            )} ${titleCityLabel}`;
            const url = getListingUri(language, cityLabel);

            return (
              <StyledListItem key={index}>
                <StyledLink href={url} title={title}>
                  {titleCityLabel}
                </StyledLink>
              </StyledListItem>
            );
          })}
        </StyledList>
      </Grid>
    </>
  );
};

export default OurCitiesList;
